import {
  templateAllPlaceholders,
  templatePlaceholderDetails,
} from "@smart/bridge-templates-basic";
import { useDebounce } from "@smart/itops-hooks-dom";
import {
  Editor,
  richMessageFeatures,
  Spinner,
} from "@smart/itops-sb-design-system-dom";

type MessageSectionProps = {
  description: string;
  loading?: boolean;
  value?: string | null;
  fallback: string;
  excludingFieldNames?: typeof templateAllPlaceholders;
  disabled?: boolean;
  save: (value?: string) => Promise<void>;
};

const MessageSection = ({
  description,
  loading,
  value,
  fallback,
  disabled,
  excludingFieldNames,
  save,
}: MessageSectionProps) => {
  const onChange = useDebounce((updated) => {
    save(updated).catch(console.error);
  }, 500);

  return (
    <div className="flex flex-col gap-xSmall max-h-[56.8rem]">
      <div className="text-ui">{description}</div>
      {loading ? (
        <Spinner size="regular" color="primary" />
      ) : (
        <Editor
          id=""
          initialTextValue={value || fallback}
          onValueChange={onChange}
          dataTestId="message-editor"
          featureOptions={richMessageFeatures}
          placeholders={{
            keys: excludingFieldNames
              ? templateAllPlaceholders.filter(
                  (key) => !excludingFieldNames.includes(key),
                )
              : templateAllPlaceholders,
            details: templatePlaceholderDetails,
            data: {},
          }}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export { MessageSection };
